export default __webpack_public_path__ + "4d3b2b5fe7f3f54da26fb9810b39a356.webp";